import React, { FocusEventHandler, useMemo } from "react";

import { useFormData } from "@sp-state/useFormData";
import InputWrapper from "../InputWrapper";

import styles from "../ProfessionsInput/ProfessionsInput.module.scss";
import stylesQuestion from "./QuestionInput.module.scss";
import { QuestionAttribute } from "@components/BuilderComponents/SignupFormDrip/sfd-components/Form/sfd-helpers/sfd-form.type";

type QuestionAttributes = {
  questionAttributes: QuestionAttribute | null;
};

const MultipleChoice = ({ questionAttributes }: QuestionAttributes) => {
  const { setQuestionError, setQuestionValid, setQuestions } = useFormData(
    state => state
  );

  const value = useMemo(() => {
    return questionAttributes?.value || [];
  }, [questionAttributes?.value]);

  const name = questionAttributes?.questionName || "";

  const onBlur: FocusEventHandler<HTMLInputElement> = e => {
    if (!e.target.checked && !questionAttributes?.questionOptional) {
      setQuestionError(name, true);
      setQuestionValid(name, false);
    }
  };

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    newValue: string
  ) => {
    const { checked } = e.target;

    const currentValue = value;

    if (!checked) {
      const filterValues = currentValue.filter(item => item !== newValue);

      setQuestions(name, filterValues);
    } else {
      setQuestions(name, [...new Set([...currentValue, newValue])]);
    }

    if (
      questionAttributes?.hasError &&
      checked &&
      !questionAttributes?.questionOptional
    ) {
      setQuestionError(name, false);
    }

    if (!questionAttributes?.isValid && checked) {
      setQuestionValid(name, true);
    }
  };

  return (
    <>
      <InputWrapper
        errorMsg="This field is required."
        hasError={questionAttributes?.hasError}
        optional={questionAttributes?.questionOptional}
        label={
          <>
            {questionAttributes?.questionTitle || ""}
            <span className={stylesQuestion.labelApplyAll}>
              (Select all that apply)
            </span>
          </>
        }
      >
        <div className={styles.selectField}>
          {questionAttributes?.questionDropdownOptions?.map((item, key) => {
            const getValue = value.includes(item?.Dropdown);

            return (
              <div key={key} className={stylesQuestion.multipleChoice}>
                <input
                  checked={getValue}
                  onBlur={onBlur}
                  onChange={e => onChange(e, item?.Dropdown)}
                  type="checkbox"
                  className={stylesQuestion.checkbox}
                />
                {item?.Dropdown}
              </div>
            );
          })}
        </div>
      </InputWrapper>
    </>
  );
};

export default MultipleChoice;
